var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockClosedIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 18,
    viewBox: "0 0 14 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42325 6.84695C3.89595 6.84695 4.27912 6.46376 4.27912 5.99108V4.27935C4.27912 2.8613 5.42864 1.71174 6.84673 1.71174C8.26482 1.71174 9.41434 2.8613 9.41434 4.27935V5.99108C9.41434 6.46376 9.79751 6.84695 10.2702 6.84695C10.7429 6.84695 11.1261 6.46376 11.1261 5.99108V4.27935C11.1261 1.91593 9.21013 0 6.84673 0C4.48333 0 2.56738 1.91593 2.56738 4.27935V5.99108C2.56738 6.46376 2.95056 6.84695 3.42325 6.84695Z",
    fill: "#49712B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 8.58544C0 7.16739 1.14956 6.01783 2.56761 6.01783H11.1263C12.5444 6.01783 13.6939 7.16739 13.6939 8.58544V15.4324C13.6939 16.8505 12.5444 18 11.1263 18H2.56761C1.14956 18 0 16.8505 0 15.4324V8.58544ZM2.56761 7.72957C2.09493 7.72957 1.71174 8.11274 1.71174 8.58544V15.4324C1.71174 15.9051 2.09493 16.2883 2.56761 16.2883H11.1263C11.599 16.2883 11.9822 15.9051 11.9822 15.4324V8.58544C11.9822 8.11274 11.599 7.72957 11.1263 7.72957H2.56761Z",
    fill: "#49712B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.55824 11.1532C8.55824 12.0985 7.7919 12.8649 6.8465 12.8649C5.90114 12.8649 5.13477 12.0985 5.13477 11.1532C5.13477 10.2078 5.90114 9.44141 6.8465 9.44141C7.7919 9.44141 8.55824 10.2078 8.55824 11.1532Z",
    fill: "#49712B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.84708 11.1531C7.31978 11.1531 7.70295 11.5362 7.70295 12.0089V13.7207C7.70295 14.1934 7.31978 14.5765 6.84708 14.5765C6.3744 14.5765 5.99121 14.1934 5.99121 13.7207V12.0089C5.99121 11.5362 6.3744 11.1531 6.84708 11.1531Z",
    fill: "#49712B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockClosedIcon);
export default __webpack_public_path__ + "static/media/lock-closed-icon.ed7e1c6e54968ac86b251757b8588c67.svg";
export { ForwardRef as ReactComponent };